module.exports = __webpack_public_path__ + "static/img/2.b461016.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.jpeg
// module id = hy6w
// module chunks = 1